export default __webpack_public_path__ + "static/media/seo-call.f9da07f0.mp3";